import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppSelector } from "store/rootReducer";

import { colors } from "global/globalStyle";

const extractQrCodeBase64 = (rawValue?: string): string | null => {
  if (!rawValue) return null;
  try {
    return JSON.parse(rawValue)?.QrCodeBase64 ?? null;
  } catch {
    return null;
  }
};

export const AccessAppQr = () => {
  const { t } = useTranslation();
  const { globalConfigurations } = useAppSelector(
    (store) => store.configurations,
  );

  const mobileQrConfig = Array.isArray(globalConfigurations)
    ? globalConfigurations.find((config: any) => config.name === "MobileQrCode")
    : undefined;

  const qrCodeBase64 = extractQrCodeBase64(mobileQrConfig?.value);

  if (!qrCodeBase64) {
    return (
      <Stack
        alignItems="center"
        justifyContent="center"
        sx={{ height: "100%" }}
      >
        <Typography
          fontFamily="Inter"
          fontSize="14px"
          sx={{ color: colors.neutral_gray_60, textAlign: "center" }}
        >
          {t("profile.accessAppEmpty")}
        </Typography>
      </Stack>
    );
  }

  const imageSource = qrCodeBase64.startsWith("data:")
    ? qrCodeBase64
    : `data:image/png;base64,${qrCodeBase64}`;

  return (
    <Stack alignItems="center" spacing={3} sx={{ paddingTop: "8px" }}>
      <Typography
        fontFamily="Inter"
        fontSize="15px"
        sx={{
          color: colors.neutral_gray_40,
          textAlign: "center",
          maxWidth: 320,
        }}
      >
        {t("profile.accessAppHelper")}
      </Typography>
      <img
        src={imageSource}
        alt={t("profile.accessApp")}
        style={{ width: 260, height: 260, imageRendering: "pixelated" }}
      />
      <Stack alignItems="center" spacing={0.5}>
        <Typography
          fontFamily="Inter"
          fontSize="14px"
          sx={{ color: colors.neutral_gray_40, textAlign: "center" }}
        >
          {t("profile.accessAppDownload")}
        </Typography>
        <a
          href="https://kenta.com.br"
          target="_blank"
          rel="noreferrer"
          style={{
            color: colors.default_blue,
            fontFamily: "Inter",
            fontSize: "14px",
            fontWeight: 600,
          }}
        >
          kenta.com.br
        </a>
      </Stack>
    </Stack>
  );
};

export default AccessAppQr;
